import { call, put, takeLatest, all } from "redux-saga/effects";
import {
  FETCH_ALL_PROMOCODE_REQUEST,
  VIEW_PROMOCODE_REQUEST,
  UPDATE_PROMOCODE_REQUEST,
  DELETE_PROMOCODE_REQUEST,
  CREATE_PROMOCODE_REQUEST,
  APPROVAL_PROMOCODE_REQUEST,
  VALIDATE_PROMOCODE_REQUEST,
} from "./PromoCodeType";

import {
  fetchAllPromoCodeSuccess,
  fetchAllPromoCodeFailure,
  viewPromoCodeSuccess,
  viewPromoCodeFailure,
  updatePromoCodeSuccess,
  updatePromoCodeFailure,
  deletePromoCodeSuccess,
  deletePromoCodeFailure,
  createPromoCodeSuccess,
  createPromoCodeFailure,
  approvalPromoCodeSuccess,
  approvalPromoCodeFailure,
  validatePromoCodeSuccess,
  validatePromoCodeFailure,
} from "./PromoCodeAction";

import {
  fetchAllPromoCodesEffect,
  viewPromoCodeEffect,
  updatePromoCodeEffect,
  deletePromoCodeEffect,
  createPromoCodeEffect,
  approvalPromoCodeEffect,
  validatePromoCodeEffect,
} from "./PromoCodeEffect";


// ============================
// FETCH ALL
// ============================
function* fetchAllPromoCodesSaga({ payload }) {
  try {
    const { data } = yield call(fetchAllPromoCodesEffect, payload);
    yield put(fetchAllPromoCodeSuccess(data));
  } catch (error) {
    yield put(fetchAllPromoCodeFailure({ message: error.message }));
  }
  
}
// ============================
// Create
// ============================
function* createPromoCodesSaga({ payload }) {
  try {
    const { data } = yield call(createPromoCodeEffect, payload);
    yield put(createPromoCodeSuccess(data));
  } catch (error) {
    yield put(createPromoCodeFailure({ message: error.message }));
  }
}

// ============================
// VIEW
// ============================
function* viewPromoCodeSaga({ payload }) {
  try {
    const { data } = yield call(viewPromoCodeEffect, payload); // payload = id
    yield put(viewPromoCodeSuccess(data));
  } catch (error) {
    yield put(viewPromoCodeFailure({ message: error.message }));
  }
}

// ============================
// UPDATE
// ============================
function* updatePromoCodeSaga({ payload }) {
  try {
    const { data } = yield call(updatePromoCodeEffect, payload);
    yield put(updatePromoCodeSuccess(data));
  } catch (error) {
    yield put(updatePromoCodeFailure({ message: error.message }));
  }
}

// ============================
// DELETE
// ============================
function* deletePromoCodeSaga({ payload }) {
  try {
    const { data } = yield call(deletePromoCodeEffect, payload); // payload = id
    yield put(deletePromoCodeSuccess(data));
  } catch (error) {
    yield put(deletePromoCodeFailure({ message: error.message }));
  }
}

// ============================
// Approval Status
// ============================
function* approvalPromoCodeSaga({ payload }) {
  try {
    const { data } = yield call(approvalPromoCodeEffect, payload);
    yield put(approvalPromoCodeSuccess(data));
  } catch (error) {
    yield put(approvalPromoCodeFailure({ message: error.message }));
  }
}

// ============================
// Validation
// ============================
function* validatePromoCodeSaga({ payload }) {
  try {
    const { data } = yield call(validatePromoCodeEffect, payload);
    console.log("data", data);
    yield put(validatePromoCodeSuccess(data));
  } catch (error) {
    console.log("error", error);
    yield put(validatePromoCodeFailure({ message: error.response.data.message }));
  }
}
// ============================
// WATCHER
// ============================
export default function* watchpromoCodeSaga() {
  yield all([
    takeLatest(FETCH_ALL_PROMOCODE_REQUEST, fetchAllPromoCodesSaga),
    takeLatest(VIEW_PROMOCODE_REQUEST, viewPromoCodeSaga),
    takeLatest(UPDATE_PROMOCODE_REQUEST, updatePromoCodeSaga),
    takeLatest(DELETE_PROMOCODE_REQUEST, deletePromoCodeSaga),
    takeLatest(CREATE_PROMOCODE_REQUEST,createPromoCodesSaga),
    takeLatest(APPROVAL_PROMOCODE_REQUEST,approvalPromoCodeSaga),
    takeLatest(VALIDATE_PROMOCODE_REQUEST,validatePromoCodeSaga)
  ]);
}
